/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgArtificialIntelligence2 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 0c4.963 0 9 4.037 9 9a8.988 8.988 0 0 1-3.384 7.028C21.189 16.34 24 19.348 24 23v1H0v-1c0-3.651 2.81-6.66 6.383-6.973A8.984 8.984 0 0 1 3 9c0-4.963 4.037-9 9-9zm5 18H7a5.01 5.01 0 0 0-4.9 4h19.799A5.01 5.01 0 0 0 17 18zM12 2C8.14 2 5 5.141 5 9c0 3.164 2.11 5.846 5 6.709v-1.406l-1.832-2.748 1.664-1.11L12 13.697V16c.694 0 1.366-.102 2-.291v-3.376L11.2 8.6l1.6-1.2 3.2 4.267v3.074A6.998 6.998 0 0 0 19 9c0-3.859-3.14-7-7-7z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgArtificialIntelligence2 as ArtificialIntelligence2 };
